import { formatPattern } from "react-router-utils";
import AccountConfirm from "./AccountConfirm";
import AccountForm from "./AccountForm";
import AccountList from "./AccountList";
import CheckoutLayout from "app/components/CheckoutLayout";
import ImmutablePropTypes from "react-immutable-proptypes";
import ModalCheckout from "app/components/ModalCheckout";
import PreviousLink from "app/components/UI/PreviousLink";
import PropTypes from "prop-types";
import React from "react";
import Title from "app/components/UI/Title";

export const CheckoutAccount = ({
  clubId,
  translate,
  searchAccount,
  setSearchAccount,
  onSubmit,
  cryptedContacts,
  cryptedContact,
  onSelect,
  isError,
  isPreparePayment,
  isOpen,
  onClose,
  onResetForm,
  onNotFound,
  onConfirmPayment,
  noCardIdentification,
  onSwitchForm,
  isFetching,
  totalUnitCount
}) => (
  <div>
    <CheckoutLayout
      header={
        <div>
          <PreviousLink to={formatPattern("/:clubId/checkout", { clubId: clubId })}>
            {translate("Revenir au panier")}
          </PreviousLink>
          <Title component="h2">{translate("Votre compte")}</Title>
        </div>
      }
      leftCol={
        <div>
          <form onSubmit={onSubmit}>
            <AccountForm
              value={searchAccount}
              onChange={setSearchAccount}
              isFetching={isFetching}
              noCardIdentification={noCardIdentification}
              onSwitchForm={onSwitchForm}
            />
          </form>
          {cryptedContacts.size ? (
            <AccountList
              contacts={cryptedContacts}
              onSelect={onSelect}
              selectedContact={cryptedContact}
              onNotFound={onNotFound}
            />
          ) : (
            ""
          )}
        </div>
      }
      rightCol={
        cryptedContact.size ? (
          <AccountConfirm
            contact={cryptedContact}
            onConfirmPayment={onConfirmPayment}
            onNotFound={onNotFound}
            isPreparePayment={isPreparePayment}
            totalUnitCount={totalUnitCount}
          />
        ) : (
          ""
        )
      }
    />

    <ModalCheckout open={isOpen} onRequestClose={onClose} isError={isError} clubId={clubId} onClick={onResetForm}>
      <p>{translate("N'hésitez pas à vérifier si toutes les informations complétées ci dessus sont correct.")}</p>
      <p>{translate("Si cela ne fonctionne toujours pas, veuillez vous rapprocher de la boutique de votre golf.")}</p>
    </ModalCheckout>
  </div>
);

CheckoutAccount.propTypes = {
  translate: PropTypes.func.isRequired,
  clubId: PropTypes.string.isRequired,
  searchAccount: PropTypes.object.isRequired,
  setSearchAccount: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cryptedContacts: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  cryptedContact: ImmutablePropTypes.map.isRequired,
  isOpen: PropTypes.bool,
  isError: PropTypes.bool,
  isPreparePayment: PropTypes.bool,
  isFetching: PropTypes.bool,
  onResetForm: PropTypes.func,
  onNotFound: PropTypes.func,
  onConfirmPayment: PropTypes.func,
  onSwitchForm: PropTypes.func
};

export default CheckoutAccount;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/CheckoutAccount.js